import React from 'react';
import './quiz.css'
import img1 from '../../../assets/quiz/Screenshot 2022-12-11 154627.png'
import img2 from '../../../assets/quiz/Screenshot 2022-12-11 154716.png'
import img3 from '../../../assets/quiz/Screenshot 2022-12-11 154733.png'

const Quiz = () => {
    return (
        <div className='mx-0 mt-8 lg:mt-10 lg:mx-10'>
            <h1 className='mb-4 text-xl font-semibold'>Quiz for programmer</h1>
            <div>
                <p className='mb-4 text-slate-800'>Here some demo image</p>
                <div className='grid grid-cols-1 gap-5 lg:grid-cols-3'>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img1} alt="" />
                    </div>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img2} alt="" />
                    </div>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img3} alt="" />
                    </div>
                </div>
                <div className='mt-5 features'>
                    <h1 className='text-xl font-semibold'>Features:</h1>
                    <p>•Four types of topic here.</p>
                    <p>•Fully Responsive(mobile).</p>
                    <p>•Each quiz have 10 quiz.</p>
                    <p>•Wrong and right quiz selection show by toast.</p>
                    <p>•There are a static page.There are a graph of quiz.</p>

                </div>
                <div className='mt-5 links'>
                    <a href="https://admirable-lily-a4cc4e.netlify.app/" className='mr-4 underline' rel="noreferrer" target="_blank">Live demo</a>
                    <a href="https://github.com/Maruf-Stack/quiz-crackers-website" rel="noreferrer" target="_blank" className='mr-4 underline'>Github client side</a>
                </div>
            </div>

        </div>
    );
};

export default Quiz;